import { Box, Typography, TextField, MenuItem, CircularProgress } from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './DropdownInput.scss';

const defaultProps = {
  label: '',
  inlineLabel: undefined,
  dropdownValues: [],
  loading: false,
  className: '',
  containerClass: '',
  labelVariant: 'h5',
};
export default function DropdownInput(props) {
  const {
    label,
    dropdownValues,
    loading,
    inlineLabel,
    className,
    containerClass,
    labelVariant,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <Box width='100%' className={`dropdown-input ${className} ${containerClass}`}>
      {loading && (
        <CircularProgress size={25} className={`spinner ${label ? '' : 'no-label'}`} />
      )}
      {label && (
        <Typography variant={labelVariant}>{label}</Typography>
      )}
      <TextField
        select
        variant='outlined'
        fullWidth
        label={inlineLabel}
        data-private
        {...rest}
        inputProps={{
          'aria-label': label || inlineLabel || 'dropdown-input',
        }}
      >
        {dropdownValues ? dropdownValues.map((l) => (
          <MenuItem
            key={l.id}
            value={l.id}
            data-test={`selector-option-${l.id}`}
            disabled={l.disabled}
            data-private
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                e.currentTarget.click();
              }
            }}
          >
            {l.name}
          </MenuItem>
        ))
          : <div />}
      </TextField>
    </Box>
  );
}
